import { Deserialize } from 'src/utils/serialization';
import { SvgIcon } from 'src/components/common';
import validate from 'src/utils/validate';
import { Button } from 'zarm';
import React from 'react';
import './init.scss';

import system_init from 'src/images/ZALogo_text.png';
import noInitiateIcon from 'src/images/initiate_text.png';
import blackIcon from 'src/images/black-icon.png';

const TEXT_ICON = {
  no_initiate: noInitiateIcon,
  black: blackIcon,
  defaults: system_init,
}
const TEXT_TYPE = {
  no_channelSource: '您当前链接无渠道信息，请打开正确链接!',
  no_auth: '您还未授权，暂时无法使用该服务!',
  no_initiate: '抱歉，无法为您发起新的问诊',
  default: '当前问诊人数过多，请稍后再试!',
}
const Error = (props) => {
  const { location: { search = '' } = {}, errorType = '' } = props;
  const { type = 'default', message = '' } = Deserialize(search);
  const prefixCls = 'init_page';
  const couplingType = errorType || type;
  let msg = decodeURIComponent(message);
  const goBack = () => {
    if (validate.isFromMiniApplet()) {
      wx.miniProgram.navigateBack({
        delta: 1
      });
    } else {
      window.history.go(-1);
    }

  }
  return (
    <div className={`${prefixCls} ${couplingType}`}>
      <SvgIcon type='img' className={`${prefixCls}_icon ${couplingType}`} src={TEXT_ICON[couplingType] || TEXT_ICON.defaults} />

      {couplingType === 'black' ? (
        <div className='black-tips'>
          <h4>因在咨询中言辞不当</h4>
          <h4>您已经被限制使用部分服务，3天后解除</h4>
          <p className={`${prefixCls}_text`}>如您已经多次言辞不当，系统将终止为您服务，不再解除限制</p>
          <Button theme='primary' shape="round" size='sm' onClick={goBack}>我知道了</Button>
        </div>
      ) : <p className={`${prefixCls}_text`}>{msg || TEXT_TYPE[couplingType]}</p>}
    </div >
  );
}

export default Error;


